/**
 * Strip PII-like patterns from analytics event payloads before GA4 / console.
 */

const EMAIL_RE = /[\w.-]+@[\w.-]+\.\w+/g;
const BEARER_RE = /Bearer\s+[A-Za-z0-9._-]+/gi;

/** Param keys we never send verbatim (may contain PII or secrets). */
const REDACT_KEYS = new Set([
  'email',
  'student_email',
  'student_name',
  'studentName',
  'educator_name',
  'educatorName',
  'access_token',
  'token',
  'authorization',
  'password',
  'phone',
  'address',
  'body',
  'message',
  'subject',
]);

function scrubString(s: string, maxLen: number): string {
  const t = s.replace(BEARER_RE, 'Bearer [REDACTED]').replace(EMAIL_RE, '[EMAIL]');
  return t.length > maxLen ? `${t.slice(0, maxLen)}…` : t;
}

export function sanitizeAnalyticsParams(
  data: Record<string, unknown>,
  maxStringLen = 120
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(data)) {
    if (REDACT_KEYS.has(k)) {
      out[k] = typeof v === 'number' ? v : '[redacted]';
      continue;
    }
    if (typeof v === 'string') {
      out[k] = scrubString(v, maxStringLen);
    } else if (typeof v === 'number' || typeof v === 'boolean') {
      out[k] = v;
    } else if (v != null) {
      out[k] = scrubString(String(v), maxStringLen);
    }
  }
  return out;
}
